import { createTypes } from 'reduxsauce'
 
export default createTypes(`
    GET_SIGN_DISCLOSURE_INITIAL_DATA
    PREPARE_DISCLOSURE
    ON_SIGNING_EVENT
    HANDLE_SIGN_DISCLOSURE_ERROR
`, {}) // options - the 2nd parameter is optional